module.exports = __webpack_public_path__ + "static/media/manual-rickshaw.fb600ac9.png";